import { Component, NgZone, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoggerService } from 'src/app/common/logging/logger.service';
import { OfficeSelectorService } from 'src/app/common/officeSelector/officeSelector.service';
import { DashboardRecruitmentService } from "src/app/dashboard-recruitment/services/dashboard-recruitment.service";
import { DoughnutChartData } from 'src/app/dashboardCommon/components/cardContents/doughnutChart.component';
import { SingleSummaryDetailKpiServiceHost } from 'src/app/dashboardCommon/components/kpiServiceHostComponent';
import { DashboardRecruitmentModel, DashboardRecruitmentResponseModel } from "src/app/dashboard-recruitment/models/dashboardRecruitment.model";
import { ImpersonationService } from 'src/app/auth/apigee/impersonation.service';

export class BucketFillExtendedData {
  public buckets: DoughnutChartData[] = [];
  public get total(): number {
    if (this.buckets) {
      return this.buckets.reduce<number>((acc, x) => acc + x.value, 0);
    } else {
      return 0;
    }
  };
  public colorPalette: string[] = ["#FFB405", "#00A5ED", "#0F1941", "#6AA4B4", '#B8D001'];
}

export class ExtendedDoughnutChartData extends DoughnutChartData {
  public link: string;
  public source: DashboardRecruitmentModel;

  constructor(label: string, labelToolTip: string, value: number, source: DashboardRecruitmentModel) {
    super(label, value, labelToolTip);
    this.source = source;
  }
}

@Component({
    selector: 'bucket-fill-out-extended-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class BucketFillOutExtendedKpiServiceHostComponent extends SingleSummaryDetailKpiServiceHost<DashboardRecruitmentService,
  DashboardRecruitmentResponseModel,
  BucketFillExtendedData,
  ExtendedDoughnutChartData> implements OnDestroy {

  public getClassName() { return "BucketFillOutExtendedKpiServiceHostComponent"; }

  private raasSubscription: Subscription;
  private officeSelectorSubscription: Subscription;

  constructor(zone: NgZone,
    logger: LoggerService,
    private impersonationService: ImpersonationService,
    private officeSelectorService: OfficeSelectorService,
    dashboardRecruitmentService: DashboardRecruitmentService) {
    super(zone, logger, dashboardRecruitmentService);
    this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
    this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
  }

  protected processSummaryData(data: DashboardRecruitmentResponseModel): BucketFillExtendedData {

    let result: BucketFillExtendedData = null;

    let sortedBuckets = data.buckets
      .filter(x => x.bucketId > 0)
      .sort((a, b) => b.orderId - a.orderId);

    if (sortedBuckets.length == 0) {
      result = null;
    }
    else {
      result = sortedBuckets
        .slice(0, 5)
        .reduce<BucketFillExtendedData>((acc, x) => {
          let branchName = x.branchName.toString().replace("bucket", "").replace("RTT", "");
          let max = branchName.length <= 10 ? 28 : 18;
          let separator = x.name.length <= max ? ' - ' : '... - '
          let textSummary = x.name.substring(0, max).concat(separator, branchName);
          let text = x.name.concat(' - ', branchName);

          acc.buckets.push(new ExtendedDoughnutChartData(textSummary,
            text,
            x.target,
            x));
          return acc;
        }, new BucketFillExtendedData());
    }

    return result;
  }

  protected extractUpdateTime(data: DashboardRecruitmentResponseModel): Date {
    return data.updateTimestamp;
  }

  protected processDetailData(data: DashboardRecruitmentResponseModel) {
    return null;
  }

  protected performDetailAction(): void {
    if (this.summaryData && this.detailData) window.open(this.detailData.link, "_blank");
  }

  public ngOnDestroy(): void {
    if (this.raasSubscription) this.raasSubscription.unsubscribe();
    if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
  }

}
